export default __webpack_public_path__ + "static/media/s1.2.17a442a7.png";